//HeatMap.ts ==============================================================
import "../Util/Prototypes";

import * as MainMap from "../MainMap";
import * as SalesSearch from "./SalesSearch";
import * as Spinner from "../Util/Spinner";
import * as Util_App from "../Util/Util_App";

import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export function create() {
   if (Spinner.busy) {
      return; //Quit if busy.
   }
   Spinner.show();

   const renderer: any = {
      type: "heatmap",
      radius: 25,
      minDensity: 0,
      maxDensity: 0.01,
      colorStops: [
         { ratio: 0, color: "rgba(0, 0, 0, 0)" },
         { ratio: 0.1, color: "rgb(0, 0, 255)" },
         { ratio: 0.3, color: "rgb(255, 0, 0)" },
         { ratio: 0.4, color: "rgb(255, 255, 0)" },
         { ratio: 0.9, color: "rgb(255, 255, 0)" },
         { ratio: 1, color: "rgb(255, 255, 255)" },
      ],
   };

   const fs = SalesSearch.layer.fs;

   const fl = new FeatureLayer({
      id: "Heat Map",
      title: "Heat Map",
      geometryType: "point",
      objectIdField: "OBJECTID",
      fields: fs.fields,
      outFields: ["*"],
      //labelsVisible: false,
      spatialReference: MainMap.activeView.spatialReference,
      legendEnabled: false,
      listMode: "hide",
      popupEnabled: false,
      renderer: renderer,
      source: fs.features,
   });

   clearHeatMap();
   MainMap.map.add(fl, 0);
   Spinner.hide();
}

//Heat map exists.
export function heatMapExists(): boolean {
   const heatMapLayer = Util_App.getOperationalLayerById("Heat Map") as __esri.FeatureLayer;
   if (heatMapLayer) {
      return true;
   }
   return false;
}

//Clear heat map.
export function clearHeatMap() {
   if (heatMapExists()) {
      const heatMapLayer = Util_App.getOperationalLayerById("Heat Map") as __esri.FeatureLayer;
      MainMap.map.remove(heatMapLayer);
   }
}
